module.exports = __webpack_public_path__ + "static/media/charisse-kenion-s_IYpaTaueQ-unsplash.3f2c7973.jpg";